(() => {
  const root = document.getElementById('eddy-welcome');
  if (!root || typeof root.showModal !== 'function') return;
  const key = 'eddyplan_welcome5_v1';
  const pendingKey = key + '_pending';
  const teaserKey = key + '_teaser_hidden';
  const safeRead = (storage, name) => { try { return JSON.parse(storage.getItem(name) || 'null'); } catch { return null; } };
  const safeWrite = (storage, name, value) => { try { storage.setItem(name, JSON.stringify(value)); } catch {} };
  const safeRemove = (storage, name) => { try { storage.removeItem(name); } catch {} };
  let local = null;
  let session = null;
  try { local = window.localStorage; } catch {}
  try { session = window.sessionStorage; } catch {}
  const pending = safeRead(session, pendingKey);
  const ours = pending && Number.isFinite(pending.at) && Date.now() - pending.at >= 0 && Date.now() - pending.at < 3600000;
  const form = root.querySelector('form');
  const sourceForm = ours ? document.getElementById(pending.form || form.id) : null;
  const result = sourceForm?.querySelector('[data-ep-result]')?.dataset.epResult;
  const success = Boolean(ours && result === 'success');
  const errors = Boolean(ours && result === 'error');
  const popupResult = sourceForm === form;
  const preview = new URLSearchParams(window.location.search).get('ep_welcome_preview') === '1' || Boolean(window.Shopify?.designMode);
  const saved = safeRead(local, key);
  const dismissed = saved && (saved.subscribed || saved.until > Date.now());
  const eligible = !success && !saved?.subscribed && root.dataset.knownCustomer !== 'true';
  const before = root.querySelector('.ep-before');
  const after = root.querySelector('.ep-after');
  const teaser = document.getElementById('ep-welcome-teaser');
  const bannerRains = new Set();
  let teaserClosed = Boolean(safeRead(session, teaserKey));
  let cssPromise;
  let oldOverflow;
  let returnFocus;
  let autoTimer;
  if (ours && (success || errors)) safeRemove(session, pendingKey);
  if (success) {
    safeWrite(local, key, { subscribed: true });
    if (popupResult) {
      before.hidden = true;
      after.hidden = false;
      root.setAttribute('aria-labelledby', 'ep-welcome-success');
    }
  }
  const loadStyle = () => {
    if (!cssPromise) cssPromise = new Promise((resolve, reject) => {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = root.dataset.css;
      link.onload = resolve;
      link.onerror = () => { link.remove(); cssPromise = null; reject(new Error('Welcome style unavailable')); };
      document.head.appendChild(link);
    });
    return cssPromise;
  };
  const loadImages = element => {
    element?.querySelectorAll('img[data-src]').forEach(img => {
      img.src = img.dataset.src;
      img.removeAttribute('data-src');
    });
  };
  const addRain = (rain, count = 52) => {
    if (!rain || rain.dataset.ready === 'true') return;
    rain.dataset.ready = 'true';
    const colors = ['#86acc6','#a7c2d5','#c3dce9','#ffffff','#8fb8cf','#d6e7f1'];
    const fragment = document.createDocumentFragment();
    for (let index = 0; index < count; index++) {
      const drop = document.createElement('span');
      const spark = index % 3 === 0;
      const violet = spark && index % 24 === 12;
      drop.className = 'ep-drop ' + (spark ? 'ep-spark' : 'ep-dust') + (violet ? ' ep-violet' : '');
      const properties = {'--ep-x':((index*37+9)%98)+'%','--ep-size':(spark?8.5+(index%4)*.55:1.8+(index%3)*.55)+'px','--ep-color':violet?'#b17cf2':colors[spark?Math.floor(index/3)%colors.length:index%colors.length],'--ep-speed':(5.1+(index%9)*.43)+'s','--ep-delay':(-((index*1.71)%9.7))+'s','--ep-sway':(-8+(index%7)*3)+'px','--ep-still':((index*29)%92)+'%'};
      Object.entries(properties).forEach(([name,value]) => drop.style.setProperty(name,value));
      if (spark) { const glint = document.createElement('i'); glint.className = 'ep-glint'; drop.appendChild(glint); }
      fragment.appendChild(drop);
    }
    rain.appendChild(fragment);
  };
  const showTeaser = () => {
    if (!teaser || root.open || teaserClosed || (!eligible && !preview)) return;
    loadImages(teaser);
    teaser.hidden = false;
  };
  const hideTeaser = () => { if (teaser) teaser.hidden = true; };
  const cancelAuto = () => window.clearTimeout(autoTimer);
  const open = async (manual = false) => {
    if (root.open) return;
    if (manual) cancelAuto();
    const consentBanner = document.getElementById('shopify-pc__banner');
    const consentVisible = consentBanner && consentBanner.getClientRects().length > 0;
    if (document.visibilityState !== 'visible' || document.querySelector('dialog[open]') || (!manual && consentVisible)) {
      if (!manual) autoTimer = window.setTimeout(() => open(), 2000);
      return;
    }
    try { await loadStyle(); } catch { showTeaser(); return; }
    if (root.open) return;
    loadImages(root);
    addRain(root.querySelector('.ep-rain'));
    returnFocus = document.activeElement;
    oldOverflow = document.body.style.overflow;
    root.hidden = false;
    root.showModal();
    hideTeaser();
    document.body.style.overflow = 'hidden';
    if (success && popupResult) root.querySelector('#ep-welcome-success').focus({preventScroll:true});
    else root.querySelector('.ep-close').focus({preventScroll:true});
  };
  const close = () => {
    if (!root.open) return;
    cancelAuto();
    root.close();
    root.hidden = true;
    document.body.style.overflow = oldOverflow || '';
    if (!success && !saved?.subscribed) safeWrite(local, key, {until:Date.now() + 7*86400000});
    showTeaser();
    if (returnFocus?.isConnected) returnFocus.focus({preventScroll:true});
  };
  root.querySelector('.ep-close').addEventListener('click', close);
  root.querySelector('.ep-later').addEventListener('click', close);
  root.querySelector('.ep-explore').addEventListener('click', close);
  root.addEventListener('cancel', event => {event.preventDefault();close();});
  root.addEventListener('click', event => {if (event.target === root) close();});
  teaser?.querySelector('.ep-teaser-open').addEventListener('click', () => open(true));
  teaser?.querySelector('.ep-teaser-close').addEventListener('click', () => {
    teaserClosed = true;
    safeWrite(session, teaserKey, true);
    hideTeaser();
  });
  const bindForm = signupForm => {
    if (signupForm.dataset.epBound) return;
    signupForm.dataset.epBound = 'true';
    signupForm.addEventListener('focusin', cancelAuto);
    signupForm.addEventListener('submit', () => {
      cancelAuto();
      safeWrite(session, pendingKey, {at:Date.now(),form:signupForm.id});
      const button = signupForm.querySelector('[type="submit"]');
      button.textContent = button.dataset.pendingLabel || 'Just a little moment…';
      button.setAttribute('aria-busy','true');
    });
  };
  bindForm(form);
  const rainObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const rain = entry.target.querySelector('[data-ep-banner-rain]');
      if (!rain) return;
      rain.dataset.visible = String(entry.isIntersecting);
      rain.dataset.paused = String(!entry.isIntersecting || document.hidden);
      if (entry.isIntersecting) loadStyle().then(() => addRain(rain, 36)).catch(() => {});
    });
  }, {threshold:0}) : null;
  const initializeBanners = () => {
    document.querySelectorAll('[data-ep-banner]').forEach(banner => {
      if (banner.dataset.epBound) return;
      banner.dataset.epBound = 'true';
      const bannerForm = banner.querySelector('form');
      if (!eligible && !preview && !(success && sourceForm === bannerForm)) {
        banner.hidden = true;
        return;
      }
      bindForm(bannerForm);
      const rain = banner.querySelector('[data-ep-banner-rain]');
      if (rain) {
        bannerRains.add(rain);
        if (rainObserver) rainObserver.observe(banner);
        else loadStyle().then(() => { addRain(rain,36); rain.dataset.paused = 'false'; }).catch(() => {});
      }
      if (success && sourceForm === bannerForm) {
        banner.querySelector('.ep-banner-before').hidden = true;
        banner.querySelector('.ep-banner-after').hidden = false;
        banner.querySelector('.ep-banner-success').focus({preventScroll:true});
      } else if (errors && sourceForm === bannerForm) {
        banner.querySelector('input[type="email"]').focus({preventScroll:true});
      }
    });
  };
  initializeBanners();
  document.addEventListener('shopify:section:load', initializeBanners);
  document.addEventListener('visibilitychange', () => {
    bannerRains.forEach(rain => {
      if (!rain.isConnected) { bannerRains.delete(rain); return; }
      rain.dataset.paused = String(document.hidden || rain.dataset.visible !== 'true');
    });
  });
  if ((success || errors) && popupResult) open();
  else if (errors) showTeaser();
  else if (preview || (!dismissed && eligible)) autoTimer = window.setTimeout(() => open(), preview ? 800 : 8000);
  else if (eligible) showTeaser();
})();
